export default __webpack_public_path__ + "static/media/DeleteFacilityCardIcon.c2945092.svg";